export function convertToCurrency(amount, style = 'currency', currency = 'GBP') {

    let formatter = new Intl.NumberFormat('en-GB', {
        style: style,
        currency: currency,
    });
    
    return formatter.format(amount / 100);
}